import { render, staticRenderFns } from "./IrregularMinutesLogsIcon.vue?vue&type=template&id=0f45d2e0&"
import script from "./IrregularMinutesLogsIcon.vue?vue&type=script&lang=js&"
export * from "./IrregularMinutesLogsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports